var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-briefcase")]),_c('router-link',{staticStyle:{"color":"rgba(0, 0, 0, 0.87)"},attrs:{"to":`/client/analytics/explorer?opportunity=${_vm.opportunity.id}`}},[_vm._v("\n        "+_vm._s(_vm.opportunity.name)+"\n      ")]),_c('v-spacer'),(_vm.opportunity.set.length)?_c('router-link',{staticStyle:{"color":"rgba(0, 0, 0, 0.87)"},attrs:{"to":`/client/analytics/explorer?set=${_vm.opportunity.set}`}},[_vm._v("\n        "+_vm._s(_vm.opportunity.set)+"\n      ")]):_vm._e()],1),_c('v-divider'),(!_vm.hasApplications)?_c('v-card-text',{staticClass:"text-xs-center"},[_c('em',[_vm._v("No applications have been recorded for this opportunity.")])]):_vm._e(),(_vm.statuses.loading || _vm.funnel.loading)?_c('v-card-text',{staticClass:"text-xs-center"},[_c('em',[_vm._v("Loading…")])]):_vm._e(),(_vm.hasApplications && !_vm.statuses.loading && !_vm.funnel.loading)?_c('v-card-text',[(!_vm.funnel.loading)?_c('apex',{attrs:{"type":"bar","width":"100%","height":_vm.linearChartSize(Object.keys(_vm.funnel).length),"options":{
          labels: [_vm.opportunity.name],
          colors: _vm.colors,
          chart: { fontFamily: 'Heebo, sans-serif', toolbar: { show: false } },
          plotOptions: {
            bar: {
              horizontal: true,
              dataLabels: { position: 'top' },
            },
          },
          tooltip: { followCursor: true },
          yaxis: { show: false },
        },"series":Object.keys(_vm.funnel).map(name => ({ name, data: [_vm.funnel[name]]}))}}):_vm._e(),(!_vm.statuses.loading)?_c('apex',{attrs:{"type":"donut","width":"100%","height":Object.keys(_vm.statuses).length < 20 ? 400 : Object.keys(_vm.statuses).length * 18,"options":{
          labels: Object.keys(_vm.statuses),
          colors: _vm.cycledColors,
          chart: { fontFamily: 'Heebo, sans-serif' },
          tooltip: { enabled: false },
          legend: { position: 'bottom' },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  total: { show: true, color: '#373d3f' },
                },
              },
            },
          },
        },"series":Object.values(_vm.statuses)}}):_vm._e()],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }